import { VisitaList } from "../../../visitas/VisitaList/VisitaList";
import { DealInformation } from "../types";
import { Dispatch, SetStateAction, useState } from "react";
import { CurrentComponent } from "../../DealInformation/components/DealInformation";
import { SaveButton } from "../../../../components/ui/SaveButton";
import { EditDealForm } from "../../EditDealForm/components/EditDealForm";
import { ToggleEditButton } from "src/components/ui/ToggleEditButton";
import { InformationSection } from "./InformationSection";

interface Props {
    deal: DealInformation;
    setCurrentComponent: Dispatch<SetStateAction<CurrentComponent>>;
}

export function DealDetails({ deal, setCurrentComponent }: Props) {
    const [showEdit, setShowEdit] = useState(false)

    return (
        <div className="flex justify-between h-full gap-x-3 flex-shrink w-full overflow-hidden">

            <div className="border border-gray-500 rounded-md py-3 w-full flex flex-col">
                <div className="flex justify-between px-2">
                    <p className="font-semibold text-[16px]">Visitas</p>

                    <SaveButton
                        onClick={() => {
                            setCurrentComponent({ component: "RegisterVisitaForm", visitaId: 0 })
                        }}
                        text="+ Agregar visita"
                        type="button"/>
                </div>

                <div className="overflow-hidden flex-1">
                    <VisitaList
                        visitas={deal.visitas}
                        setCurrentComponent={setCurrentComponent} />
                </div>
            </div>

            <div className="border border-gray-500 rounded-md p-3 w-[500px] overflow-auto">
                <div className="flex justify-between items-center pb-3">
                    <p className="font-semibold text-lg">{showEdit ? "Actualizar información" : "Información de la camapaña"}</p>

                    <ToggleEditButton
                        toggleEdit={showEdit}
                        onClick={() => setShowEdit(!showEdit)}/>
                </div>

                {showEdit
                ?
                <EditDealForm
                    deal={{
                        id: deal.id,
                        prospectadorId: 0,
                        fechaInicio: deal.fechaInicio,
                        fechaFin: deal.fechaFin,
                    }}
                    onCancel={() => setShowEdit(false)}/>
                :
                <InformationSection deal={deal}/>
                }
            </div>
        </div>
    );
}
